export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDescr: true,
  title: "Sobre Nosotros",
  headline: "Somos una librería con más de 10 años en el rubro",
  description:
    "Sabemos lo que hacemos y damos lo mejor para cada cliente, un trato personalizado, rapidez y calidad nos describen perfectamente.",
  buttonName: "SERVICIOS",
  imgStart: false,
  img: require("../../images/imagen1.png"),
  alt: "welcome",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "services",
  lightBg: true,
  lightText: false,
  lightTextDescr: false,
  title: "Servicios",
  headline: "Esto es lo que te ofrecemos y muchos más",
  description:
    "Fotocopias, impresiones, librería, gigantografías, estampados, gorras, tazas, sublimación, turnos/papeles del ANSES, revelado de fotos, armado de CV, anillados, etc.",
  buttonName: "UBICACIÓN",
  imgStart: true,
  img: require("../../images/imagen2.png"),
  alt: "services",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "ubication",
  lightBg: false,
  lightText: true,
  lightTextDescr: true,
  imgStart: false,
  img: require("../../images/imagen3.png"),
  alt: "ubication",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjFour = {
    id: "contact",
    lightBg: true,
    lightText: false,
    lightTextDescr: false,
    imgStart: true,
    img: require("../../images/imagen4.png"),
    alt: "contact",
    dark: false,
    primary: false,
    darkText: true,
  };
